import { getComponentFromName } from '@folklore/utils';

import { useBrand, useDefaultBrand } from '../../contexts/SiteContext';
import * as SectionComponents from './sections';

export interface SectionPageProps {
    slug: string;
    brand?: string | null;
    type?: string | null;
    className?: string | null;
}

function SectionPage({ brand: brandSlug = null, slug, ...props }: SectionPageProps) {
    const hasBrand = brandSlug !== null;
    const { handle: defaultBrandHandle = 'urbania' } = useDefaultBrand();
    const brand = useBrand(brandSlug, !hasBrand ? defaultBrandHandle : null);
    const { handle: brandHandle = null, sections = [] } = brand || {};
    const section = sections.find(({ slug: sectionSlug }) => sectionSlug === slug) || null;

    const SectionComponent =
        getComponentFromName(SectionComponents, slug) ||
        getComponentFromName(SectionComponents, brandHandle, 'default');
    return <SectionComponent brand={brand} section={section} {...props} />;
}

export default SectionPage;
